import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { HomeList } from '@src/components/sco/Education/HomeLanding/HomeList';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { EducationPage } from '@src/templates/EducationPage';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default EducationPage(function Page() {
  const layout = useParentAppLayout();
  const educationContext = useEducationContext();
  useUniversalEffect(() => {
    layout.updatePanel('edu-aside', {
      isPanelOpen: false
      // isDrawerOpen: false,
    });
    educationContext.setBreadcrumbs([{
      title: 'Education',
      href: '/education'
    }]);
    educationContext.setActiveSection('education.landing');
    educationContext.setActiveContentItem(null);
  }, []);
  return <HomeList />;
});